export const TAG_COLOR_PALETTE = [
  '#7C3AED',
  '#0891B2',
  '#16A34A',
  '#DC2626',
  '#EA580C',
  '#2563EB',
  '#DB2777',
  '#CA8A04',
  '#0D9488',
  '#9333EA',
  '#059669',
  '#B91C1C',
] as const

const hash = (input: string): number => {
  let h = 5381
  for (let i = 0; i < input.length; i++) {
    h = ((h << 5) + h + input.charCodeAt(i)) | 0
  }
  return Math.abs(h)
}

export type GroupColorResolver = (
  desc: string | null | undefined,
) => string | undefined

export const createGroupColorMap = (
  descriptions: Iterable<string | null | undefined>,
  palette: readonly string[] = TAG_COLOR_PALETTE,
): GroupColorResolver => {
  const seen = new Set<string>()
  const ordered: string[] = []
  for (const raw of descriptions) {
    const key = raw?.trim()
    if (!key || seen.has(key)) continue
    seen.add(key)
    ordered.push(key)
  }

  const map = new Map<string, string>()
  const usedSlots = new Set<number>()
  ordered.forEach((key) => {
    const start = hash(key) % palette.length
    let slot = start
    if (ordered.length <= palette.length) {
      while (usedSlots.has(slot)) {
        slot = (slot + 1) % palette.length
      }
      usedSlots.add(slot)
    }
    map.set(key, palette[slot])
  })

  return (desc) => {
    const key = desc?.trim()
    if (!key) return undefined
    if (!map.has(key)) {
      map.set(key, palette[hash(key) % palette.length])
    }
    return map.get(key)
  }
}
